import type { SVGProps } from "react";
import { memo } from "react";

import { cn } from "@btnet/utilities-core";

import "./Icon.less";
import type { IIconProps } from "./Icon.types";

const SvgIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    fill="none"
    viewBox="0 0 32 32"
    {...props}
  >
    <path
      fill="currentColor"
      d="M24.698 16.133 18.25 13.75l-2.375-6.452a1.99 1.99 0 0 0-3.735 0L9.75 13.75l-6.452 2.375a1.99 1.99 0 0 0 0 3.735l6.452 2.39 2.375 6.453a1.99 1.99 0 0 0 3.735 0l2.39-6.453 6.453-2.375a1.99 1.99 0 0 0 0-3.735Zm-7.573 4.395a1 1 0 0 0-.592.592L14 27.981l-2.527-6.856a1 1 0 0 0-.598-.598L4.019 18l6.856-2.527a1 1 0 0 0 .598-.598L14 8.019l2.528 6.856a1 1 0 0 0 .592.593L23.981 18ZM18 5a1 1 0 0 1 1-1h2V2a1 1 0 0 1 2 0v2h2a1 1 0 0 1 0 2h-2v2a1 1 0 0 1-2 0V6h-2a1 1 0 0 1-1-1m13 6a1 1 0 0 1-1 1h-1v1a1 1 0 0 1-2 0v-1h-1a1 1 0 0 1 0-2h1V9a1 1 0 0 1 2 0v1h1a1 1 0 0 1 1 1"
    />
  </svg>
);
const SvgIconSparkle = ({
  testid,
  size = "md",
  className,
  ariaLabel,
  innerRef,
  ...props
}: IIconProps) => {
  const ariaVisibilityProp = ariaLabel
    ? {
        "aria-label": ariaLabel,
      }
    : {
        "aria-hidden": true,
      };
  return (
    <div
      data-testid={testid}
      className={cn("icon bds-icon", className, {
        ["bds-icon-" + size]: size,
        ["icon-" + size]: size,
      })}
      ref={innerRef}
      {...props}
    >
      <SvgIcon role="img" fill="none" {...ariaVisibilityProp} />
    </div>
  );
};
const Memo = memo(SvgIconSparkle);
export default Memo;
